import {GenerationKeyState} from './states/generation-key.state';

export const generationState = [
    GenerationKeyState
];
